module.exports = __webpack_public_path__ + "img/chartapp.675e88dd.jpg";